namespace $.$$ {

	$mol_style_define( $shm_radio, {

		'[disabled]': {
			true: {
				color: $mol_theme.shade,
			},
		},

		Icon: {
			width: '1rem',
			height: '1rem',
			flex: {
				shrink: 0,
			},
			align: {
				self: 'center',
				items: 'center',
			},
			justify: {
				content: 'center',
			},
			border: {
				radius: '50%',
			},
			box: {
				shadow: [[ 'inset', 0, 0, 0, '1px', $mol_theme.line ]],
			},
			background: {
				color: $mol_theme.field,
			},
		},

		Circle_inner: {
			width: '.4rem',
			height: '.4rem',
			border: {
				radius: '50%',
			},
			background: {
				color: $mol_theme.text,
			},
		},

	} )

}
